var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generated_files_area"},[(_vm.$store.state.general.pluginName !== '')?_c('v-jstree',{attrs:{"data":_vm.$store.state.fileArchitecture},on:{"item-click":_vm.itemClick}}):_c('p',[_c('i',[_vm._v("No Preview Available")])]),(_vm.$store.state.general.pluginName !== '')?_c('code-modal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }